module.exports = __webpack_public_path__ + "static/media/tempPic.8bed6f5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/LessonPath/static/img/dialog/tempPic.png
// module id = 696
// module chunks = 1